import { Pipe, PipeTransform } from '@angular/core';
import { isPlainObject, isString } from 'lodash';

@Pipe({
  name: 'getObjectKeyOrString'
})
export class GetObjectKeyOrStringPipe implements PipeTransform {

  transform(value: any, key: string): any {
    if (isPlainObject(value)) {
      return value[key] ? value[key] : 'Key not found';
    } else if (isString(value)) {
      return value;
    } else {
      return undefined;
    }
  }

}
